module.exports = __webpack_public_path__ + "img/logo-bold-white-stroke.9442ccb2.png";